import { render } from "./CheckoutPositions.vue?vue&type=template&id=b2869ebe"
import script from "./CheckoutPositions.vue?vue&type=script&lang=js"
export * from "./CheckoutPositions.vue?vue&type=script&lang=js"

import "./CheckoutPositions.vue?vue&type=style&index=0&id=b2869ebe&lang=css"

import exportComponent from "/Users/andrei/Desktop/EO LARAVEL/club-shops-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__